// @flow

import { NavLink as ReactRouterNavLink } from 'react-router-dom';

import WithPortal from './WithPortal';

const NavLink = WithPortal('to')(ReactRouterNavLink);

export default NavLink;
